import { render, staticRenderFns } from "./live.vue?vue&type=template&id=a6256b6a&scoped=true"
import script from "./live.vue?vue&type=script&lang=js"
export * from "./live.vue?vue&type=script&lang=js"
import style0 from "./live.vue?vue&type=style&index=0&id=a6256b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6256b6a",
  null
  
)

export default component.exports